import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIS } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class ApisService {

  constructor(private httpClient: HttpClient) { }

  private authHeaders(token: string) {
    return { headers: new HttpHeaders({ Authorization: `Bearer ${token}` }) };
  }

  getWeeklyAnalysis(userId: String, date: String, token: string) {
    console.log("heaeder :: ", this.authHeaders(token));
    
    return this.httpClient.get(
      APIS.aiApiBaseUrl + `week-analysis?id=${userId}&date=${date}&voice=true`,
      this.authHeaders(token)
    );
  }

  getOneDayMacros(userId: String, date: String, token: string) {
    return this.httpClient.get(
      APIS.aiApiBaseUrl + `get_day_macros/${userId}/${date}`,
      this.authHeaders(token)
    );
  }

  getOneDayImprovements(userId: String, date: String, token: string) {
    return this.httpClient.get(
      APIS.aiApiBaseUrl + `get_day_improvements?id=${userId}&date=${date}&voice=true`,
      this.authHeaders(token)
    );
  }

  getDayAnalysis(userId: String, date: String, token: string) {
    return this.httpClient.get(
      APIS.aiApiBaseUrl + `get_day_analysis?id=${userId}&date=${date}&voice=true`,
      this.authHeaders(token)
    );
  }
}
